import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import LightingText from '../src/components/popup/LightingText';

const Aydinlatma: NextPage = () => {
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Aydınlatma Metni | Pembe Panjur'}
                description={'Pembe Panjur aydınlatma metni ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} hamburgerMenuType={'black'}
                        registerButton={true}>
                <LightingText />
            </WaveLayout>
        </React.Fragment>

    )
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default Aydinlatma;
